import React from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'

import { Form, Text, TextArea, Number as NumberInput } from 'components/forms'

const ConceptItem = ({ formData, onSubmit }) => {
	const [t] = useTranslation()

	return(
		<Form initialValues={formData} smartSubmit onSubmit={onSubmit} updateByInitial>
			<div><Text field='dbIndex' hidden /></div>
			<Row>
				<Col xs>
					<Text field='productName' placeholder='Einnahmen Rechnungen' label={t('common.fields.name')} />
					<TextArea field='buttonCaption' placeholder='Einnahmen Rechnungen' label={t('product_section.fields.alt_name')} />
				</Col>
				<Col xs>
					<Text field='nameInOrder' placeholder='Einnahmen Rechnungen' label={t('product_section.fields.optional_order_name')} />
					<TextArea field='application' placeholder='Anwendung' label={t('product_section.fields.application')} />
				</Col>
				<Col xs>
					{formData.prices.map((price, i, arr) => (
						<NumberInput
							key={i}
							field={`prices[${i}]`}
							format='currency'
							placeholder={`Preis ${i + 1}`}
							{...i === 0 && { label: `${t('product_section.strings.price')} 1-${arr.length}` }}
							withControls={false}
							shrink />
					))}
				</Col>
			</Row>
		</Form>
	)
}

export default ConceptItem
